import _ from 'lodash';
import { Record } from 'immutable';
import { RECEIVE_CITIES } from '../constants';

const InitialState = Record({
  items: [],
});

const initialState = new InitialState();

export default function citiesReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_CITIES:
      return state.set('items', _.sortBy(action.payload));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/cities/reducer.js